import { type JSX, type PropsWithChildren } from 'react';

import { cn } from '@videoblocks/design-system';

import { DotSpinner } from '../../_components/DotSpinner/DotSpinner';
import { GenerationFlowLayout } from './GenerationFlowLayout';

export interface GenerationFlowInProgressLayoutProps extends PropsWithChildren {
    title?: string;
    subtitle?: string;
    className?: string;
}

export const GenerationFlowInProgressLayout = ({
    title = 'Your video is generating...',
    subtitle = 'Your generation may take a few minutes.',
    className,
    children,
}: GenerationFlowInProgressLayoutProps): JSX.Element => {
    return (
        <GenerationFlowLayout className={cn('w-full h-full gap-5', className)} title={title} subtitle={subtitle}>
            {children || <DotSpinner size="default" variant="standalone" />}
        </GenerationFlowLayout>
    );
};
